import React, { useState } from "react";
import "./ToggleSwitch.css";

const ToggleSwitch = ({ labels, onClick }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleClick = (index) => {
    setActiveIndex(index);
    if (onClick) {
      onClick(index);
    }
  };

  return (
    <div className="toggle-switch">

      {labels.map((label, index) => (
        <div
          key={index}
          className={`toggle-option ${activeIndex === index ? "active" : ""}`}
          onClick={() => handleClick(index)}
        >
          {label}
        </div>
      ))}

    </div>
  );
};

export default ToggleSwitch;
